import { render, staticRenderFns } from "./new-tab.vue?vue&type=template&id=53403709"
import script from "./new-tab.vue?vue&type=script&lang=js"
export * from "./new-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports